/* Webbly. Pagina de produs v6: selectorul de pachete si bara de jos. */
(function () {
  'use strict';

  function el(sel, root) { return (root || document).querySelector(sel); }

  var box = el('[data-ths6]');
  if (!box) return;

  var prag = parseInt(box.getAttribute('data-prag'), 10) || 180;
  var packs = box.querySelectorAll('.ths6-pack');
  var bar = el('[data-ths6-bar]');

  /* Textele vin din `locales/<limba>.json` prin atribute pe container.
     Inainte erau scrise romaneste aici, deci bara spunea „Mai ai 135 lei pana
     la livrarea gratuita" si pe engleza. JS-ul nu are acces la filtrul `t`. */
  function bani(n) {
    var f = box.getAttribute('data-money-format') || '{{amount}}';
    return f.replace(/\{\{[^}]*\}\}/, n);
  }

  /* Cat e deja in cos. Bara calcula numai pretul pachetului ales, deci cineva
     cu doua produse in cos vedea acelasi „mai ai atat" ca unul cu cosul gol.
     Tema nu emite niciun eveniment de cos, asa ca se citeste din `/cart.js`,
     la fiecare adaugare si la revenirea pe fila. */
  var cos = parseFloat(box.getAttribute('data-cos') || '0') || 0;

  function reincarcaCos() {
    if (!window.fetch) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) {
        if (!c) return;
        cos = (c.total_price || 0) / 100;
        /* `arata` recalculeaza si bara, cu cantitatea si reducerea aleasa. */
        arata();
      })
      .catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('form[action*="/cart/add"] [type="submit"]');
    if (b) setTimeout(reincarcaCos, 1200);
  }, true);
  window.addEventListener('pageshow', reincarcaCos);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) reincarcaCos();
  });

  function ship(lei) {
    var t = el('[data-ths6-shiptext]', box);
    var b = el('[data-ths6-shipbar]', box);
    if (!t || !b) return;
    lei = (lei || 0) + cos;
    if (lei >= prag) {
      t.innerHTML = '<b>' + (box.getAttribute('data-t-gratis') || '') + '</b> '
                  + (box.getAttribute('data-t-inclusa') || '');
      t.classList.add('is-free'); b.classList.add('is-free');
      b.firstElementChild.style.width = '100%';
    } else {
      var sablon = box.getAttribute('data-t-prag') || '%s';
      t.innerHTML = sablon.replace('%s', '<b>' + bani(prag - lei) + '</b>');
      t.classList.remove('is-free'); b.classList.remove('is-free');
      b.firstElementChild.style.width = Math.round(lei / prag * 100) + '%';
    }
  }

  /* Suma in subdiviziuni, formatata dupa formatul de bani al pietei. `bani`
     de mai sus pune numarul asa cum e, bun pentru pragul rotund de livrare,
     dar nu pentru un total cu reducere, care are zecimale. */
  function suma(c) {
    var f = box.getAttribute('data-money-format') || '{{amount}}';
    var m = f.match(/\{\{\s*(\w+)\s*\}\}/);
    var k = m ? m[1] : 'amount';
    function g(zec, mii, virg) {
      var p = (c / 100).toFixed(zec).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, mii);
      return p.join(virg);
    }
    var v;
    if (k === 'amount_no_decimals') v = g(0, ',', '.');
    else if (k === 'amount_with_comma_separator') v = g(2, '.', ',');
    else if (k === 'amount_no_decimals_with_comma_separator') v = g(0, '.', ',');
    else if (k === 'amount_with_apostrophe_separator') v = g(2, "'", '.');
    else v = g(2, ',', '.');
    return f.replace(/\{\{[^}]*\}\}/, v);
  }

  /* ---- cantitatea ----
     Reducerea pe cantitate o aplica Shopify in cos, prin doua reduceri automate
     pe produsele individuale. Aici doar se arata, cu aceleasi procente, puse in
     setarile blocului. Pe seturi treptele se ascund si totalul e pret ori bucati. */
  var qbox = el('[data-ths6-qty]', box);
  var qin = qbox && el('[data-ths6-q]', qbox);
  var qmax = qbox ? (parseInt(qbox.getAttribute('data-max'), 10) || 3) : 1;
  var r2 = qbox ? (parseFloat(qbox.getAttribute('data-r2')) || 0) : 0;
  var r3 = qbox ? (parseFloat(qbox.getAttribute('data-r3')) || 0) : 0;
  var q = 1;
  var ales = null;

  function procent(n) {
    if (n >= 3 && r3) return r3;
    if (n >= 2 && r2) return r2;
    return 0;
  }

  /* Formularele de cumparare: cel principal al temei si cel din bara de jos.
     Inainte doar bara urma pachetul ales, deci butonul principal adauga produsul
     simplu chiar cand pe ecran era ales setul. */
  function formulare() {
    var f = [];
    document.querySelectorAll('.product-area form[action*="/cart/add"], [data-ths6-bar] form[action*="/cart/add"]')
      .forEach(function (x) { if (f.indexOf(x) < 0) f.push(x); });
    return f;
  }

  function sincron(id) {
    formulare().forEach(function (f) {
      if (id) {
        var i = f.querySelector('[name="id"]');
        if (i) i.value = id;
      }
      f.querySelectorAll('[name="quantity"]').forEach(function (x) { x.value = q; });
    });
  }

  function date() {
    if (ales) return ales.dataset;
    return {
      cents: box.getAttribute('data-cents'),
      simplu: box.getAttribute('data-simplu'),
      value: box.getAttribute('data-valoare')
    };
  }

  function arata() {
    var d = date();
    var c = parseInt(d.cents, 10);
    var pret = el('[data-ths6-price]', box);
    var old = el('[data-ths6-old]', box);
    var off = el('[data-ths6-off]', box);
    var simplu = d.simplu === '1';
    var total, vechi = 0, eticheta = '';

    if (qbox) {
      qbox.classList.toggle('is-set', !simplu);
      qbox.querySelectorAll('.ths6-tier').forEach(function (t) {
        t.classList.toggle('is-on', simplu && procent(q) > 0 && parseInt(t.getAttribute('data-q'), 10) === Math.min(q, 3));
      });
      var mi = el('[data-ths6-minus]', qbox), pl = el('[data-ths6-plus]', qbox);
      if (mi) mi.disabled = q <= 1;
      if (pl) pl.disabled = q >= qmax;
      if (qin) qin.value = q;
    }

    if (isNaN(c)) {
      /* Fara pret numeric, raman textele randate de server. */
      if (ales) {
        if (pret) pret.textContent = d.price;
        if (old) { old.textContent = d.old || ''; old.hidden = !d.old; }
        if (off) { off.textContent = d.save ? '−' + d.save : ''; off.hidden = !d.save; }
      }
      ship(parseInt(d.value, 10) * q);
      return;
    }

    var pr = simplu ? procent(q) : 0;
    if (pr) {
      vechi = c * q;
      total = vechi - Math.round(vechi * pr / 100);
      eticheta = '−' + pr + '%';
    } else {
      total = c * q;
      var oc = parseInt(d.oldCents, 10);
      if (oc > c) {
        vechi = oc * q;
        eticheta = '−' + suma(vechi - total).replace(/[.,]00(?=\D*$)/, '');
      }
    }
    if (pret) pret.textContent = suma(total);
    if (old) { old.textContent = vechi ? suma(vechi) : ''; old.hidden = !vechi; }
    if (off) { off.textContent = eticheta; off.hidden = !eticheta; }
    var bp = bar && el('[data-ths6-bar-price]', bar);
    if (bp) bp.textContent = suma(total);
    ship(total / 100);
  }

  function seteaza(n) {
    n = parseInt(n, 10);
    if (isNaN(n) || n < 1) n = 1;
    if (n > qmax) n = qmax;
    q = n;
    sincron(null);
    arata();
  }

  if (qbox) {
    qbox.addEventListener('click', function (e) {
      var t = e.target.closest('button');
      if (!t) return;
      if (t.hasAttribute('data-ths6-minus')) seteaza(q - 1);
      else if (t.hasAttribute('data-ths6-plus')) seteaza(q + 1);
      else if (t.hasAttribute('data-q')) seteaza(t.getAttribute('data-q'));
    });
    if (qin) qin.addEventListener('change', function () { seteaza(qin.value); });
  }

  function apply(p) {
    var d = p.dataset;
    var nota = el('[data-ths6-note]', box);
    ales = p;
    if (nota && d.note) nota.textContent = d.note;
    sincron(d.id);
    arata();

    if (bar) {
      var bt = el('[data-ths6-bar-title]', bar);
      var bs = el('[data-ths6-bar-sub]', bar);
      var bp = el('[data-ths6-bar-price]', bar);
      var bi = el('[data-ths6-bar-img]', bar);
      var bid = el('[data-ths6-bar-id]', bar);
      if (bt) bt.textContent = d.title;
      if (bs) bs.textContent = d.sub || '';
      if (bp && isNaN(parseInt(d.cents, 10))) bp.textContent = d.price;
      if (bi && d.img) bi.src = d.img;
      if (bid) bid.value = d.id;
    }
  }

  packs.forEach(function (p) {
    p.addEventListener('click', function () {
      packs.forEach(function (x) {
        x.classList.remove('is-on');
        x.setAttribute('aria-checked', 'false');
      });
      p.classList.add('is-on');
      p.setAttribute('aria-checked', 'true');
      apply(p);
    });
  });

  var pornit = box.querySelector('.ths6-pack.is-on');
  if (pornit) {
    apply(pornit);
  } else if (qbox) {
    sincron(null);
    arata();
  } else {
    var b = el('[data-ths6-shipbar]', box);
    if (b) ship(parseInt(box.getAttribute('data-valoare') || '0', 10));
  }
})();
